import React, { useEffect, useState } from "react";
import { validateLeadershipTable } from "../../../../utils/validateTable";
import { restructureData } from "../../../../utils/restructureData";
import { get, put } from "../../../../utils/api";
import { Box, Button, Typography } from "@mui/material";
import DynamicTable from "../../../Common/DynamicTable";
import RadioButtons from "../../../Common/RadioButtons";
import EastIcon from "@mui/icons-material/East";
import Multiline from "../../../Masters/Multiline";
import RadioNAButtons from "../../../Common/RadioNAButtons";
import MessagePopup from "../../../Masters/MessagePopup";
import style from "../../../../styles/brsr/general.module.css";
import { useNavigate, useParams } from "react-router-dom";
import { brsrReview, reviewBRSR } from "../../../../utils/companyId";
import ReviewBox from "../../../Common/ReviewBox";
import { currentYear } from "../../../../utils/generateYearRanges";
import BRSRFile from "../../../Common/BRSRFile";

const LeadershipIndicator = ({
  onSave,
  hide,
  removeUpload = false,
  downloadMode = false,
}) => {
  const navigate = useNavigate();
  const { id } = useParams();

  const channelsData = [
    {
      fieldName: "channelsForProductInformation",
      letter: "1.",
      title:
        "1. Channels / platforms where information on products and services of the entity can be accessed (provide web link, if available).",
      type: "array",
      fields: [
        {
          fieldName: "chennel",
          title: "Channel/Platform Name",
          placeholder: "Enter Text",
          width: "15rem",
          type: "text",
        },
        {
          fieldName: "link",
          title: "Link (If Any)",
          placeholder: "Enter Link",
          type: "text",
          width: "20rem",
          optional: true,
        },
      ],
    },
  ];

  const [tabErrors, setTabErrors] = useState({});
  const [tables, setTables] = useState([]);
  const [errors, setErrors] = useState({});
  const [data, setData] = useState({});
  const [disabled, setDisabled] = useState(false);
  const [modalupload, setModalUpload] = useState({
    channelsForProductInformationDoc: false,
    consumerEducationDoc: false,
    riskDisclosureMechanismsDoc: false,
    productInformationDisplayedDoc: false,
    consumerSatisfactionSurveyDoc: false,
  });
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const res = await get(
        `/brsr/get?subType=principle9&type=SectionC&id=${id}`,
      );
      if (
        res?.data?.data?.year
          ? res?.data?.data?.year < currentYear - 1
          : false || !brsrReview
      )
        setDisabled(true);

      const res1 = res.data.data.BRSRSectionC.principle9.leadershipIndicator;
      setData(res1);
    } catch (err) {
      console.log(err);
    }
  };

  const [formData, setFormData] = useState({});

  useEffect(() => {
    setFormData({
      channelsForProductInformationDoc:
        data?.channelsForProductInformationDoc ?? [],
      consumerEducationDoc: data?.consumerEducationDoc ?? [],
      riskDisclosureMechanismsDoc: data?.riskDisclosureMechanismsDoc ?? [],
      productInformationDisplayedDoc:
        data?.productInformationDisplayedDoc ?? [],
      consumerSatisfactionSurveyDoc: data?.consumerSatisfactionSurveyDoc ?? [],
      channelsForProductInformation: data?.channelsForProductInformation ?? [
        { chennel: "", link: "" },
      ],
      consumerEducation: data?.consumerEducation ?? "",
      riskDisclosureMechanisms: data?.riskDisclosureMechanisms ?? "",
      productInformationDisplayed: data?.productInformationDisplayed ?? {
        action: "true",
        remark: "",
      },
      consumerSatisfactionSurvey: data?.consumerSatisfactionSurvey ?? {
        action: true,
        remark: "",
      },
    });
  }, [data]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const [field, key] = name.split(".");

    if (name === "consumerEducation" || name === "riskDisclosureMechanisms") {
      setFormData((prev) => ({
        ...prev,
        [name]: value, // Update the specific key
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [field]: {
          ...prev[field], // Correctly access the dynamic field
          [key]: value, // Update the specific key
        },
      }));
    }

    setErrors((prev) => ({
      ...prev,
      [name]: "", // Update the specific key
    }));
  };

  const validateForm = () => {
    const newErrors = {};
    // if (formData?.consumerEducation === "") {
    //   newErrors["consumerEducation"] = "Required";
    // }
    // if (formData?.riskDisclosureMechanisms === "") {
    //   newErrors["riskDisclosureMechanisms"] = "Required";
    // }
    if (
      formData?.productInformationDisplayed?.action === "true" &&
      formData?.productInformationDisplayed?.remark === ""
    ) {
      newErrors["productInformationDisplayed.remark"] =
        "This field is Required";
    }
    if (
      formData?.consumerSatisfactionSurvey?.action === true &&
      formData?.consumerSatisfactionSurvey?.remark === ""
    ) {
      newErrors["consumerSatisfactionSurvey.remark"] = "This field is Required";
    }
    if (formData?.consumerSatisfactionSurvey?.action !== true) {
      setFormData((prev) => ({
        ...prev,
        consumerSatisfactionSurvey: {
          ...prev.consumerSatisfactionSurvey,
          remark: "",
        },
      }));
    }
    if (formData?.productInformationDisplayed?.action !== "true") {
      setFormData((prev) => ({
        ...prev,
        productInformationDisplayed: {
          ...prev.productInformationDisplayed,
          remark: "",
        },
      }));
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!disabled) {
      // let v1 = validateLeadershipTable(channelsData, tables, setTabErrors);
      let v2 = validateForm();
      if (!v2) return;

      let transformedData = restructureData(tables);

      let transformedData2 = {
        leadershipIndicator: {
          ...formData,
          ...transformedData,
        },
        leadershipIndicatorSubmitted: true,
        type: "SectionC",
        subType: "principle9",
      };

      console.log(transformedData2);

      try {
        const res = await put(`/brsr/update?id=${id}`, transformedData2);
        // const res1 = await put(`/brsr/updateBRSR?id=${id}`, {
        //   status: "Completed",
        // });

        // console.log(res1, "res1");
        setsnackOpen({
          open: true,
          message: res?.data?.message,
          severity: "success",
        });
        onSave();
        const response = await get(`/brsr/get/status?id=${id}`);
        if (response?.data?.brsrSubmitted === false) navigate("/brsr");
        else navigate(`/brsr/review/${id}`);
      } catch (error) {
        console.log(error);
        setsnackOpen({
          open: true,
          message: error?.data?.message,
          severity: "error",
        });
      }
    } else navigate(`/brsr/review/${id}`);
  };

  return (
    <Box>
      <p className={style.subHeading}>II. LEADERSHIP INDICATOR</p>
      <MessagePopup {...{ snackOpen, setsnackOpen }} />{" "}
      <DynamicTable
        {...{
          hide,
          inputData: channelsData,
          disabled,
          handleSubmit,
          tables,
          setTables,
          errors: tabErrors,
          setErrors: setTabErrors,
          data: data,
        }}
      />
      <BRSRFile
        {...{
          modalupload,
          setModalUpload,
          formData,
          setFormData,
          errors,
          setErrors,
          Uploadkey: "channelsForProductInformationDoc",
          ml: 2,
          removeUpload,
        }}
      />
      {/* 2 */}
      <Typography variant="subtitle1" sx={{ fontWeight: "bold", my: "1rem" }}>
        2. Steps taken to inform and educate consumers about safe and
        responsible usage of products and/or services.
      </Typography>
      <Box sx={{ ml: 2 }}>
        <Multiline
          {...{
            handleChange,
            disabled,
            placeholder: "Describe here",
            errors: errors["consumerEducation"] && true,
            fieldName: "consumerEducation",
            value: formData?.consumerEducation,
          }}
        />
        <p
          color="error"
          variant="caption"
          style={{
            lineHeight: "1.2",
            margin: "2px 0",
            marginTop: "5px",
            color: "#d34040",
            fontSize: "10px",
            fontStyle: "italic",
          }}
        >
          {errors["consumerEducation"]}
        </p>
      </Box>
      <BRSRFile
        {...{
          modalupload,
          setModalUpload,
          formData,
          setFormData,
          errors,
          setErrors,
          Uploadkey: "consumerEducationDoc",
          ml: 2,
          removeUpload,
        }}
      />
      {/* 3 */}
      <Typography variant="subtitle1" sx={{ fontWeight: "bold", my: "1rem" }}>
        3. Mechanisms in place to inform consumers of any risk of disruption /
        discontinuation of essential services.
      </Typography>
      <Box sx={{ ml: 2 }}>
        <Multiline
          {...{
            handleChange,
            disabled,
            placeholder: "Describe here",
            errors: errors["riskDisclosureMechanisms"] && true,
            fieldName: "riskDisclosureMechanisms",
            value: formData?.riskDisclosureMechanisms,
          }}
        />
        <p
          color="error"
          variant="caption"
          style={{
            lineHeight: "1.2",
            margin: "2px 0",
            marginTop: "5px",
            color: "#d34040",
            fontSize: "10px",
            fontStyle: "italic",
          }}
        >
          {errors["riskDisclosureMechanisms"]}
        </p>
      </Box>
      <BRSRFile
        {...{
          modalupload,
          setModalUpload,
          formData,
          setFormData,
          errors,
          setErrors,
          Uploadkey: "riskDisclosureMechanismsDoc",
          ml: 2,
          removeUpload,
        }}
      />
      {/* 4 */}
      <RadioNAButtons
        disabled={disabled}
        title={
          "4. Does the entity display product information on the product over and above what is mandated as per local laws? (Yes / No / Not Applicable)"
        }
        value={formData?.productInformationDisplayed?.action || false}
        handleChange={handleChange}
        name="productInformationDisplayed.action"
      />
      {formData?.productInformationDisplayed?.action === "true" && (
        <Box sx={{ ml: 2 }}>
          <Multiline
            {...{
              handleChange,
              disabled,
              placeholder: "Describe here",
              errors: errors["productInformationDisplayed.remark"] && true,
              fieldName: "productInformationDisplayed.remark",
              value: formData?.productInformationDisplayed?.remark,
            }}
          />
          <p
            color="error"
            variant="caption"
            style={{
              lineHeight: "1.2",
              margin: "2px 0",
              marginTop: "5px",
              color: "#d34040",
              fontSize: "10px",
              fontStyle: "italic",
            }}
          >
            {errors["productInformationDisplayed.remark"]}
          </p>
        </Box>
      )}
      <BRSRFile
        {...{
          modalupload,
          setModalUpload,
          formData,
          setFormData,
          errors,
          setErrors,
          Uploadkey: "productInformationDisplayedDoc",
          ml: 2,
          removeUpload,
        }}
      />
      {/* 5 */}
      {downloadMode && <Box sx={{ pageBreakBefore: "always" }}></Box>}
      <RadioButtons
        disabled={disabled}
        title={
          "5. Did your entity carry out any survey with regard to consumer satisfaction relating to the major products / services of the entity, significant locations of operation of the entity or the entity as a whole? (Yes/No)"
        }
        value={formData?.consumerSatisfactionSurvey?.action || false}
        handleChange={(e) => {
          const value = e.target.value === "true"; // Convert string to boolean
          setFormData((prev) => ({
            ...prev,
            consumerSatisfactionSurvey: {
              ...prev.consumerSatisfactionSurvey,
              action: value,
            },
          }));
          // setErrors((prev) => ({
          //   ...prev,
          //   consumerSatisfactionSurvey: {
          //     ...(prev.consumerSatisfactionSurvey || {}), // Ensure this object exists
          //     remark: "", // Reset the remark error
          //   },
          // }));
        }}
      />
      {formData?.consumerSatisfactionSurvey?.action && (
        <Box sx={{ ml: 2.5 }}>
          <Multiline
            {...{
              disabled,
              handleChange,
              placeholder: "Describe here",
              errors: errors["consumerSatisfactionSurvey.remark"] && true,
              fieldName: "consumerSatisfactionSurvey.remark",
              value: formData?.consumerSatisfactionSurvey?.remark,
            }}
          />
          <p
            color="error"
            variant="caption"
            style={{
              lineHeight: "1.2",
              margin: "2px 0",
              color: "#d34040",
              fontSize: "10px",
              fontStyle: "italic",
            }}
          >
            {errors["consumerSatisfactionSurvey.remark"]}
          </p>
        </Box>
      )}
      <BRSRFile
        {...{
          modalupload,
          setModalUpload,
          formData,
          setFormData,
          errors,
          setErrors,
          Uploadkey: "consumerSatisfactionSurveyDoc",
          ml: 2.5,
          removeUpload,
        }}
      />
      {!hide && (
        <>
          {brsrReview ? (
            <Box sx={{ ml: "1.2rem", width: "98%" }}>
              <ReviewBox
                url={`/brsr/review/${id}`}
                handleSubmit={handleSubmit}
              />
            </Box>
          ) : (
            <Box textAlign="right" sx={{ mt: 3 }}>
              <Button
                onClick={handleSubmit}
                variant="contained"
                sx={{ bgcolor: "#1C486B", textTransform: "none", mt: 3, mb: 5 }}
              >
                Submit <EastIcon sx={{ ml: 2 }} />
              </Button>
            </Box>
          )}
        </>
      )}
    </Box>
  );
};

export default LeadershipIndicator;
